/** `CGuildMarkImage::MARK_WIDTH`/`MARK_HEIGHT` (`MarkImage.h:13-14`): one
 *  guild's cell of the mark page, drawn at scale 1 over a name tail. */
export const GUILD_MARK_WIDTH_PX = 16;
export const GUILD_MARK_HEIGHT_PX = 12;

/** `c_fxMarkPosition` (`PythonTextTail.cpp:20`). */
const MARK_GAP_PX = 1.5;
/** `c_fyMarkPosition` (`PythonTextTail.cpp:22`). */
const MARK_LIFT_PX = 15 + 11;

/** Where `CPythonTextTail::UpdateAllTextTail` stands a guild member's mark
 *  (`PythonTextTail.cpp:219-231`): `iImageHalfSize` is the mark's half width
 *  plus the gap, truncated to an int, and the mark's left edge sits two of
 *  those left of the guild name's own left edge, its top `c_fyMarkPosition`
 *  above the tail. `nameLeftPx` is the guild name's left edge as drawn. */
export function guildMarkRect(
  nameLeftPx: number,
  tailYPx: number,
): { x: number; y: number; width: number; height: number } {
  const imageHalfSize = Math.trunc(GUILD_MARK_WIDTH_PX / 2 + MARK_GAP_PX);
  return {
    x: nameLeftPx - 2 * imageHalfSize,
    y: tailYPx - MARK_LIFT_PX,
    width: GUILD_MARK_WIDTH_PX,
    height: GUILD_MARK_HEIGHT_PX,
  };
}

/** One guild's served sign as the pixels `CGraphicMarkInstance::OnRender`
 *  maps onto its quad (`GrpMarkInstance.cpp:51-116`): 768 samples of red,
 *  green, blue and alpha, each pixel opaque or clear exactly as the emblem
 *  panel draws it. Null for a sign that is not one whole mark. */
export function guildMarkPixels(rgba: readonly number[]): Uint8ClampedArray<ArrayBuffer> | null {
  const pixels = GUILD_MARK_WIDTH_PX * GUILD_MARK_HEIGHT_PX;
  if (rgba.length !== pixels * 4) return null;
  const out = new Uint8ClampedArray(pixels * 4);
  for (let pixel = 0; pixel < pixels; pixel += 1) {
    const base = pixel * 4;
    if (rgba[base + 3] < 128) continue;
    out[base] = rgba[base];
    out[base + 1] = rgba[base + 1];
    out[base + 2] = rgba[base + 2];
    out[base + 3] = 255;
  }
  return out;
}

/** The guild ids in `guildIds` whose sign has not been asked for yet, in the
 *  order first named, each recorded in `asked` so it is asked for once. Zero is
 *  no guild. `RegisterCharacterTextTail` looks a guild's mark up when it
 *  registers a member's tail (`PythonTextTail.cpp:540-562`); here the sign is
 *  fetched the first time a plate names its guild. */
export function emblemsToAsk(guildIds: Iterable<number>, asked: Set<number>): number[] {
  const out: number[] = [];
  for (const guildId of guildIds) {
    if (guildId === 0 || asked.has(guildId)) continue;
    asked.add(guildId);
    out.push(guildId);
  }
  return out;
}
